<page-loader *ngIf="!isLoaded"></page-loader>
<div id="page-push-notify" class="page-section series-form-page" *ngIf="isLoaded">
    <div class="app-l-page__navigation">
        <div class="app-l-page__previous" [routerLink]="['/app']">
            <button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
                <svg-icon icon="arrow-left" class="w-100 h-100"></svg-icon>
            </button>
        </div>
        <div class="app-l-page__breadcrumbs">
            <ul class="breadcrumbs-list">
                <li class="breadcrumbs-list-item app-l-current-page">
                    Scheduled Push Notifications
                </li>
            </ul>
        </div>
    </div>

    <div class="page-section-content">
        <my-tabs>
            <my-tab tabTitle="Push Notifications ({{ notificationCount }})">
                <div class="tab-header">
                    <button class="app-c-btn app-c-btn--primary app-c-btn--curve" (click)="doCreate()">
                        <svg-icon icon="notification" class="btn-icon"></svg-icon> Schedule a Push Notification
                    </button>
                </div>
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th translate>Title</th>
                                <th translate>Body</th>
                                <th translate>Scheduled Date</th>
                                <th translate>Audience</th>
                                <th translate>Created by</th>
                                <th translate>Recurring</th>
                                <th class="actions-col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let pushNotification of pushNotifications | filter : 'status' : 1">
                                <td class="strong">{{ pushNotification.revisions[0].title }}</td>
                                <td>{{ pushNotification.revisions[0].body }}</td>
                                <td>{{ pushNotification.scheduledDate | date:'MM/dd/yyyy':'UTC' }}</td>
                                <td>{{ pushNotification.orgNames }}</td>
                                <td>{{ pushNotification.user?.Name }} ({{ pushNotification.user?.Email }})</td>
                                <td>{{ pushNotification.recurring ? 'Yes' : 'No' }}</td>
                                <td class="actions-col">
                                    <button *ngIf="!pushNotification.lastExecutedTime"
                                        class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                                        (click)="onEdit(pushNotification.id)" title="Edit">
                                        <svg-icon icon="edit" class="w-100 h-100"></svg-icon>
                                    </button>
                                    <button *ngIf="!pushNotification.lastExecutedTime"
                                        class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20 delete-btn"
                                        (click)="onDelete(pushNotification.id)" title="Delete">
                                        <svg-icon icon="trash" class="w-100 h-100"></svg-icon>
                                    </button>
                                    <button *ngIf="user.id !== pushNotification.createdByUserId && isAdmin && !pushNotification.lastExecutedTime"
                                        class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                                        (click)="reject(pushNotification.id)" title="Reject">
                                        <svg-icon icon="close" class="w-100 h-100"></svg-icon>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p *ngIf="notificationCount === 0" class="empty-state">No scheduled push notifications.</p>
                </div>
            </my-tab>

            <my-tab *ngIf="isAdmin" tabTitle="For Approval ({{ approvalCount }})">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th translate>Title</th>
                                <th translate>Body</th>
                                <th translate>Scheduled Date</th>
                                <th translate>Audience</th>
                                <th translate>Created by</th>
                                <th translate>Recurring</th>
                                <th class="actions-col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let pushNotification of pushNotifications | filter : 'status' : 0">
                                <td class="strong">{{ pushNotification.revisions[0].title }}</td>
                                <td>{{ pushNotification.revisions[0].body }}</td>
                                <td>{{ pushNotification.scheduledDate | date:'MM/dd/yyyy':'UTC' }}</td>
                                <td>{{ pushNotification.orgNames }}</td>
                                <td>{{ pushNotification.user?.Name }} ({{ pushNotification.user?.Email }})</td>
                                <td>{{ pushNotification.recurring ? 'Yes' : 'No' }}</td>
                                <td class="actions-col">
                                    <button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                                        (click)="approve(pushNotification.id)" title="Approve">
                                        <svg-icon icon="tick-circle" class="w-100 h-100"></svg-icon>
                                    </button>
                                    <button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                                        (click)="reject(pushNotification.id)" title="Reject">
                                        <svg-icon icon="close" class="w-100 h-100"></svg-icon>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p *ngIf="approvalCount === 0" class="empty-state">No notifications waiting for approval.</p>
                </div>
            </my-tab>

            <my-tab *ngIf="isAdmin" tabTitle="Rejected ({{ rejectedCount }})">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th translate>Title</th>
                                <th translate>Body</th>
                                <th translate>Scheduled Date</th>
                                <th translate>Audience</th>
                                <th translate>Created by</th>
                                <th translate>Recurring</th>
                                <th class="actions-col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let pushNotification of pushNotifications | filter : 'status' : 2">
                                <td class="strong">{{ pushNotification.revisions[0].title }}</td>
                                <td>{{ pushNotification.revisions[0].body }}</td>
                                <td>{{ pushNotification.scheduledDate | date:'MM/dd/yyyy':'UTC' }}</td>
                                <td>{{ pushNotification.orgNames }}</td>
                                <td>{{ pushNotification.user?.Name }} ({{ pushNotification.user?.Email }})</td>
                                <td>{{ pushNotification.recurring ? 'Yes' : 'No' }}</td>
                                <td class="actions-col">
                                    <button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                                        (click)="approve(pushNotification.id)" title="Approve">
                                        <svg-icon icon="tick-circle" class="w-100 h-100"></svg-icon>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p *ngIf="rejectedCount === 0" class="empty-state">No rejected notifications.</p>
                </div>
            </my-tab>
        </my-tabs>
    </div>
</div>
